import { useRecord } from "./useRecord";

export function useOrganization(organizationId?: string | null) {
  return useRecord("organization", organizationId, { name: "useOrganization" });
}
